import { render } from "./InstanceEditorLink.vue?vue&type=template&id=478cdb5c"
import script from "./InstanceEditorLink.vue?vue&type=script&lang=js"
export * from "./InstanceEditorLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__